import { RouteType } from "types/RouteType";
import CommandCenterStore from "./CommandCenterStore";

const commandCenterRoute: RouteType[] = [
  {
    name: "Home",
    path: "/home",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: false, // Home is the root: there is nothing to go back to.
        title: "Command Center",
        enableRefreshButton: true,
        component: () => import("./CommandCenter.Header"),
      },
      body: {
        component: () => import("./CommandCenter.Body"),
        grayBackground: true,
      },
    },
    group: "Dashboard & Overview",
    // "dashboard" was dropped (2026-10-26) when the Developer Dashboard became
    // the landing route, so page search for it offers the board, not this page.
    searchAliases: ["overview", "landing"],
    // Every authenticated staff tier may see the dashboard, and
    // `dashboard-summary` enforces its own staff-read tier server-side. The one
    // gated element is the capability-readiness card + its attention row: the
    // store checks `isAdmin` and never issues that request for anyone else (the
    // API gates the service behind requireAdminAccess), so a non-admin gets the
    // page with that section ABSENT rather than empty or erroring.
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      // Idempotent: fetches the rollup (and, for an admin, capability
      // readiness — in parallel, failing independently), starts the 60s
      // auto-refresh interval, and subscribes to live devops-event activity
      // (the header Refresh button re-runs this).
      const store = rootStore.commandCenterStore as CommandCenterStore;
      void store?.initialize();
    },
    onExit: ({ rootStore }) => {
      // Tear down the interval + realtime subscription (refcounted socket).
      const store = rootStore.commandCenterStore as CommandCenterStore;
      store?.dispose();
    },
  },
];

export default commandCenterRoute;
